export function previousMonthInputValue(now = new Date()): string {
  const year = now.getFullYear();
  const month = now.getMonth();
  const previousYear = month === 0 ? year - 1 : year;
  const previousMonth = month === 0 ? 12 : month;
  return `${previousYear}-${String(previousMonth).padStart(2, '0')}`;
}

export function currentMonthInputValue(now = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function clampMonthInputValue(value: string, now = new Date()): string {
  if (!/^\d{4}-\d{2}$/.test(value)) return value;
  const maxMonth = currentMonthInputValue(now);
  return value > maxMonth ? maxMonth : value;
}

export function toApiMonthValue(value: string): string {
  if (/^\d{4}-\d{2}$/.test(value)) {
    return `${value}-01`;
  }
  return value;
}

export function fromApiMonthValue(value: string | null | undefined): string {
  if (!value) return '';
  return value.slice(0, 7);
}

type NativeDateInput = {
  showPicker?: () => void;
  focus?: () => void;
};

export function openNativeDatePicker(input: NativeDateInput | null | undefined): void {
  if (!input) return;
  if (typeof input.showPicker === 'function') {
    try {
      input.showPicker();
      return;
    } catch {
      // Some browsers reject showPicker outside supported user-activation paths.
    }
  }
  input.focus?.();
}
